<template>
  <div class="login-outer">
    <div class="login-page">
      <!-- 左侧面板：蓝紫色渐变 + 品牌 + 装饰图形 -->
      <div class="left-panel">
      <div class="brand-section">
        <img src="../assets/logo.png" alt="Logo" class="logo">
        <h1 class="brand-title">全优隆分销后台</h1>
        <p class="brand-desc">打造独立自主的流量广告变现王国</p>
      </div>
      <!-- CSS装饰图形区 -->
      <div class="illustration">
        <div class="il-circle il-circle-1"></div>
        <div class="il-circle il-circle-2"></div>
        <div class="il-circle il-circle-3"></div>
        <div class="il-dot il-dot-1"></div>
        <div class="il-dot il-dot-2"></div>
        <div class="il-dot il-dot-3"></div>
        <div class="il-dot il-dot-4"></div>
        <div class="il-bar il-bar-1"></div>
        <div class="il-bar il-bar-2"></div>
        <div class="il-bar il-bar-3"></div>
        <div class="il-bar il-bar-4"></div>
        <div class="il-rect il-rect-1"></div>
        <div class="il-rect il-rect-2"></div>
      </div>
    </div>

    <!-- 右侧面板：白色卡片 + 登录表单 -->
    <div class="right-panel">
      <div class="login-wrapper">
        <div class="login-header">
          <h2>欢迎登录</h2>
          <p>请输入您的账号和密码</p>
        </div>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="0px">
          <el-form-item prop="username">
            <el-input
                v-model="loginForm.username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <div class="form-extra">
            <el-checkbox v-model="rememberMe">记住账号</el-checkbox>
            <a href="#" @click.prevent="showForgotPassword">忘记密码</a>
          </div>
          <el-form-item>
            <el-button
                type="primary"
                class="login-btn"
                @click="handleLogin"
                :loading="loading"
            >
              登 录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
/**
 * 解码 JWT token 的 payload 部分（不验证签名）
 * @param {string} token - JWT token 字符串
 * @returns {object|null} 解码后的 payload 对象
 */
function parseJwtPayload(token) {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    // base64url 转 base64，再解码
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false,
      rememberMe: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await fetch('/admin/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                username: this.loginForm.username,
                password: this.loginForm.password
              })
            });

            const result = await response.json();

            if(result.code === 200 && result.data && result.data.token) {
              const token = result.data.token
              localStorage.setItem('token', token)

              // 从 JWT token payload 中解码用户信息
              const payload = parseJwtPayload(token)
              if (!payload) {
                localStorage.removeItem('token')
                this.$message.error('解析登录信息失败')
                this.loading = false
                return
              }

              // 检查账号是否被禁用
              if (payload.status === 1) {
                localStorage.removeItem('token')
                this.$message.error('该账号已被禁用，请联系超级管理员')
                this.loading = false
                return
              }

              // 确保存入的是整数，避免字符串/undefined 导致权限判断错误
              const roleVal = parseInt(payload.role, 10)
              const statusVal = parseInt(payload.status, 10)

              console.log('[Login] JWT payload:', payload)
              console.log('[Login] 解析 role:', roleVal, 'status:', statusVal)

              localStorage.setItem('role', !isNaN(roleVal) ? roleVal : 0)
              localStorage.setItem('status', !isNaN(statusVal) ? statusVal : 0)
              localStorage.setItem('username', payload.username || this.loginForm.username)
              // 优先从 JWT payload 获取 adminid，其次从登录响应体
              const userId = payload.adminid || payload.adminId || result.data.id || result.data.userId || payload.id || payload.userId || payload.sub || ''
              localStorage.setItem('userId', userId)
              console.log('[Login] 存储 userId:', userId)

              if (this.rememberMe) {
                localStorage.setItem('rememberedUsername', this.loginForm.username);
              } else {
                localStorage.removeItem('rememberedUsername');
              }

              this.$router.push('/ad-revenue');
              this.$message.success('登录成功');
            } else {
              this.$message.error(result.msg || '登录失败：未返回有效数据');
            }
          } catch (error) {
            this.$message.error(error.message || '登录失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    showForgotPassword() {
      this.$message.info('请联系系统管理员重置密码');
    },
    showContactAdmin() {
      this.$message.info('请联系系统管理员获取帮助');
    }
  },
  mounted() {
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    if (rememberedUsername) {
      this.loginForm.username = rememberedUsername;
      this.rememberMe = true;
    }
  }
}
</script>

<style scoped>
/* ========== 外层容器：全屏居中 ========== */
.login-outer {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #e2e5ec 0%, #edf0f5 35%, #f4f6f9 65%, #f9fafc 100%);
}

/* ========== 登录卡片容器：占页面70% ========== */
.login-page {
  display: flex;
  width: 70vw;
  height: 70vh;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

/* ========== 左侧面板：蓝紫色渐变背景 ========== */
.left-panel {
  flex: 1;
  background: linear-gradient(160deg, #1e1b4b 0%, #3730a3 30%, #5865f2 60%, #818cf8 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 40px;
}

/* 二级光斑（增加层次感） */
.left-panel::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -20%;
  width: 80%;
  height: 80%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%);
  pointer-events: none;
}

.left-panel::after {
  content: '';
  position: absolute;
  bottom: -15%;
  left: -10%;
  width: 60%;
  height: 60%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(129, 140, 248, 0.12) 0%, transparent 70%);
  pointer-events: none;
}

/* 品牌区 */
.brand-section {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #ffffff;
  margin-bottom: 50px;
}

.logo {
  width: 72px;
  height: 72px;
  margin-bottom: 24px;
  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.2));
}

.brand-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 12px;
  letter-spacing: 2px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.brand-desc {
  font-size: 0.95rem;
  opacity: 0.8;
  margin: 0;
  letter-spacing: 1px;
}

/* ========== 装饰图形 ========== */
.illustration {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}

/* 圆形 */
.il-circle {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.il-circle-1 {
  width: 200px;
  height: 200px;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  border: 3px dashed rgba(255,255,255,0.3);
  animation: spinSlow 20s linear infinite;
}
.il-circle-2 {
  width: 140px;
  height: 140px;
  top: 22%;
  left: 50%;
  transform: translateX(-50%);
  border: 2px solid rgba(255,255,255,0.25);
  animation: spinSlow 15s linear infinite reverse;
}
.il-circle-3 {
  width: 80px;
  height: 80px;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  border: 2px solid rgba(255,255,255,0.4);
  background: rgba(255,255,255,0.12);
}

/* 光点 — 散开分布 */
.il-dot {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  background: rgba(255,255,255,0.85);
  box-shadow: 0 0 8px rgba(255,255,255,0.4);
  animation: dotBlink 2s ease-in-out infinite;
}
.il-dot-1 { width: 10px; height: 10px; top: 12%; left: 15%; animation-delay: 0s; }
.il-dot-2 { width: 8px; height: 8px; top: 18%; right: 12%; animation-delay: 0.5s; }
.il-dot-3 { width: 10px; height: 10px; bottom: 28%; left: 8%; animation-delay: 1s; }
.il-dot-4 { width: 6px; height: 6px; bottom: 35%; right: 16%; animation-delay: 1.5s; }

/* 柱形条 — 分散底部 */
.il-bar {
  position: absolute;
  border-radius: 4px 4px 0 0;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(255,255,255,0.4), rgba(255,255,255,0.1));
  animation: barGrow 3s ease-in-out infinite;
}
.il-bar-1 { width: 12px; height: 60px; bottom: 18%; left: 12%; animation-delay: 0s; }
.il-bar-2 { width: 12px; height: 85px; bottom: 18%; left: 20%; animation-delay: 0.3s; }
.il-bar-3 { width: 12px; height: 50px; bottom: 18%; right: 20%; animation-delay: 0.6s; }
.il-bar-4 { width: 12px; height: 100px; bottom: 18%; right: 12%; animation-delay: 0.9s; }

/* 矩形悬浮 — 右上角 */
.il-rect {
  position: absolute;
  border-radius: 8px;
  pointer-events: none;
}
.il-rect-1 {
  width: 55px;
  height: 55px;
  top: 10%;
  right: 10%;
  border: 2px solid rgba(255,255,255,0.3);
  transform: rotate(25deg);
  animation: floatRect 4s ease-in-out infinite;
}
.il-rect-2 {
  width: 36px;
  height: 36px;
  top: 24%;
  right: 18%;
  background: rgba(255,255,255,0.15);
  border-radius: 6px;
  transform: rotate(15deg);
  animation: floatRect 4s ease-in-out infinite 1s;
}

@keyframes spinSlow {
  to { transform: rotate(360deg); }
}
@keyframes dotBlink {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}
@keyframes barGrow {
  0%, 100% { opacity: 0.5; transform: scaleY(0.85); transform-origin: bottom; }
  50% { opacity: 0.9; transform: scaleY(1.05); transform-origin: bottom; }
}
@keyframes floatRect {
  0%, 100% { transform: rotate(25deg) translateY(0); }
  50% { transform: rotate(25deg) translateY(-10px); }
}

/* ========== 右侧面板：白色背景 ========== */
.right-panel {
  flex: 1;
  background: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.login-wrapper {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 20px;
  padding: 48px 40px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.08);
  animation: fadeInUp 0.6s ease-out;
}

.login-header {
  text-align: center;
  margin-bottom: 36px;
}

.login-header h2 {
  margin: 0 0 8px;
  font-size: 26px;
  font-weight: 700;
  color: #1a1a2e;
}

.login-header p {
  margin: 0;
  font-size: 14px;
  color: #555b6e;
}

/* 表单 */
.form-extra {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  padding: 0 4px;
}

.form-extra a {
  font-size: 13px;
  color: #5865f2;
  text-decoration: none;
}
.form-extra a:hover {
  color: #4f5ae6;
}

.login-btn {
  width: 100%;
  height: 46px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 4px;
  background: linear-gradient(135deg, #5865f2, #6b76f5, #818cf8) !important;
  border: none !important;
  box-shadow: 0 4px 16px rgba(88, 101, 242, 0.35);
  transition: transform 0.2s, box-shadow 0.2s;
}
.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(88, 101, 242, 0.45) !important;
}

/* Element UI 覆盖 */
.login-page .el-input__inner {
  border-radius: 8px;
  height: 46px;
  line-height: 46px;
  border: 1px solid #e4e7ed;
  background: #fafbfc;
  transition: border-color 0.3s;
}
.login-page .el-input__inner:focus {
  border-color: #5865f2;
}
.login-page .el-input__prefix {
  line-height: 46px;
  color: #c0c4cc;
}
.login-page .el-checkbox__label {
  font-size: 13px;
  color: #606266;
}

/* 动画 */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ========== 响应式 ========== */
@media screen and (max-width: 768px) {
  .login-outer {
    background: #f5f7fa;
  }
  .login-page {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
    flex-direction: column;
  }
  .left-panel {
    flex: none;
    padding: 40px 24px;
    min-height: 320px;
  }
  .illustration {
    display: none;
  }
  .brand-title {
    font-size: 1.5rem;
  }
  .right-panel {
    flex: 1;
    padding: 24px 16px;
  }
  .login-wrapper {
    padding: 32px 24px;
    box-shadow: none;
    border-radius: 0;
  }
}

@media screen and (max-width: 480px) {
  .left-panel {
    min-height: 200px;
    padding: 30px 16px;
  }
  .brand-title {
    font-size: 1.3rem;
  }
  .brand-desc {
    font-size: 0.8rem;
  }
  .login-wrapper {
    padding: 24px 16px;
  }
}
</style>